// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"2b21faac","118":"4ee40cff","511":"d552e17b"}[chunkId] + ".chunk.js";
};